const createScriptElement = (
  createElement: (
    tagName?: string
  ) => HTMLScriptElement = document.createElement.bind(document)
): HTMLScriptElement => createElement('script');

const loadScript = ({
  src = '',
  appendToParent = true,
  parent = document.body,
  scriptElement = createScriptElement(),
}: {
  src?: string;
  appendToParent?: boolean;
  parent?: HTMLElement;
  scriptElement?: HTMLScriptElement;
}): Promise<HTMLScriptElement> => {
  return new Promise((resolve, reject) => {
    scriptElement.onload = () => {
      resolve(scriptElement);
    };

    scriptElement.onerror = () => {
      reject(scriptElement);
    };

    scriptElement.src = src;

    if (appendToParent) {
      parent?.appendChild(scriptElement);
    }
  });
};

export { createScriptElement, loadScript };
